import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../services/api";
import Constants from "../../services/constants";
import {
  hideLoader,
  hideSkelton,
  showLoader,
  showSkelton,
} from "./loaderSlice";
import { showToast } from "./toastSlice";

const initialState = {
  data: null,
  all: [],
  members: [],
  invitationDetails: {},
  invitedUsers: [],
};

export const getTeamAction = createAsyncThunk(
  "team/get",
  async ({ id }, { dispatch }) => {
    try {
      //   dispatch(showLoader());
      const res = await api("get", Constants.END_POINT.team + id, {});
      if (res?.success && res?.data) {
        dispatch(setTeamDetails(res?.data));
      } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
      //   dispatch(hideLoader());
    }
  }
);

export const manageTeamAction = createAsyncThunk(
  "team/create",
  async ({ data, next }, { dispatch }) => {
    try {
      dispatch(showLoader());
      const res = await api(
        "post",
        (data?.length
          ? Constants.END_POINT.multiple_team
          : Constants.END_POINT.team) + (data?.id ? "update/" + data?.id : ""),
        data
      );
      if (res?.success && res?.data) {
        dispatch(setTeamDetails(res?.data));
        next();
      } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const getAllTeamsAction = createAsyncThunk(
  "team/get",
  async ({ org_id }, { dispatch }) => {
    try {
      dispatch(showLoader());
      const res = await api(
        "get",
        Constants.END_POINT.organization + org_id + "/teams",
        {}
      );
      if (res?.success && res?.data) {
        dispatch(setAllTeamsDetails(res?.data));
        return Promise.resolve(res?.data);
      } else {
        dispatch(setAllTeamsDetails([]));
        dispatch(showToast({ severity: "error", summary: res.message }));
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const getTeamMemberAction = createAsyncThunk(
  "team/get",
  async ({ team_id }, { dispatch }) => {
    try {
      dispatch(showSkelton());
      const res = await api(
        "get",
        Constants.END_POINT.team + team_id + "/members",
        {}
      );
      if (res?.success && res?.data) {
        dispatch(setTeamMembers(res?.data));
        dispatch(hideSkelton());
        return Promise.resolve(res?.data);
      } else {
        dispatch(hideLoader());
        dispatch(setTeamMembers([]));
        dispatch(showToast({ severity: "error", summary: res.message }));
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(setTeamMembers([]));
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
      dispatch(hideSkelton());
    }
  }
);

export const getMyTeamsAction = createAsyncThunk(
  "team/get",
  async (org_id, { dispatch }) => {
    try {
      dispatch(showSkelton());
      const res = await api(
        "get",
        Constants.END_POINT.myTeams + `?id=${org_id}`,
        {}
      );
      if (res?.success && res?.data) {
        dispatch(setAllTeamsDetails(res?.data));
        return Promise.resolve(res?.data);
      } else {
        dispatch(setAllTeamsDetails([]));
        dispatch(hideLoader());
        dispatch(
          showToast({
            severity: "error",
            summary: res?.data?.message || "Something went wrong",
          })
        );
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const deleteTeamAction = createAsyncThunk(
  "team/delete",
  async ({ team_id, next }, { dispatch }) => {
    try {
      //   dispatch(showLoader());
      const res = await api(
        "delete",
        Constants.END_POINT.team + "/" + team_id,
        {}
      );
      if (res?.success && res?.data) {
        next();
        dispatch(showToast({ severity: "success", summary: res.message }));

        return Promise.resolve(res?.data);
      } else {
        next();
        dispatch(showToast({ severity: "error", summary: res.message }));
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      next();
      return Promise.reject("An error occurred.");
    } finally {
      //   dispatch(hideLoader());
    }
  }
);

export const inviteAction = createAsyncThunk(
  "team/invite-member",
  async ({ data, next }, { dispatch }) => {
    try {
      dispatch(showLoader());

      const res = await api("post", Constants.END_POINT.invite_member, data);
      if (res?.success && res?.data) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        next();
      } else {
        dispatch(
          showToast({
            severity: "error",
            summary: res?.data?.message || res.message,
          })
        );
        return Promise.resolve(res.message || res?.data?.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const handleInviteAction = createAsyncThunk(
  "team/handle-invite",
  async ({ data, next }, { dispatch }) => {
    try {
      dispatch(showLoader());
      const res = await api("post", Constants.END_POINT.handle_invite, data);
      if (res?.success) {
        localStorage.setItem("inviteStatus", res?.data?.accepted);
        // Removed success toast notification
        next();
      } else {
        dispatch(
          showToast({
            severity: "error",
            summary: res?.data?.message || res?.message,
          })
        );
        return Promise.reject(res?.message);
      }
    } catch (error) {
      console.error(error);
      dispatch(showToast({ severity: "error", summary: error?.message }));
      return Promise.reject("An error occurred.");
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const inviteDetailsAction = createAsyncThunk(
  "team/invite-details",
  async ({ inviteId, navigate }, { dispatch }) => {
    try {
      dispatch(showLoader());

      const res = await api(
        "get",
        Constants.END_POINT.invite_details + inviteId
      );
      if (res?.success && res?.data) {
        if (res?.data?.status !== "invited") {
          dispatch(
            showToast({ severity: "error", summary: "Invalid Invitation" })
          );
          navigate("/");
        }
        dispatch(setInviteDetails(res?.data));
      } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const allInvitationAction = createAsyncThunk(
  "team/invite-details",
  async ({ teamId }, { dispatch }) => {
    try {
      dispatch(showLoader());

      const res = await api(
        "get",
        Constants.END_POINT.all_invitations + teamId
      );
      if (res?.success && res?.data) {
        dispatch(setInvitedUsers(res?.data));
      } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const deleteMembersAction = createAsyncThunk(
  "team/delete_members",
  async ({ data }, { dispatch }) => {
    try {
      dispatch(showLoader());
      const res = await api("post", Constants.END_POINT.delete_members, data);
      if (res?.success && res?.data) {
        dispatch(showToast({ severity: "success", summary: res.message }));
        dispatch(getTeamMemberAction({ team_id: data?.team_id }));
      } else {
        dispatch(showToast({ severity: "error", summary: res.message }));
        return Promise.reject(res.message);
      }
    } catch (error) {
      dispatch(showToast({ severity: "error", summary: error.message }));
      return Promise.reject("An error occurred.");
    } finally {
      dispatch(hideLoader());
    }
  }
);

const teamSlice = createSlice({
  name: "team",
  initialState,
  reducers: {
    setTeamDetails: (state, action) => {
      state.data = action.payload;
    },
    setAllTeamsDetails: (state, action) => {
      state.all = action.payload;
    },
    setTeamMembers: (state, action) => {
      state.members = action.payload;
    },
    setInviteDetails: (state, action) => {
      state.invitationDetails = action.payload;
    },
    setInvitedUsers: (state, action) => {
      state.invitedUser = action.payload;
    },
  },
});

export const {
  setTeamDetails,
  setAllTeamsDetails,
  setTeamMembers,
  setInviteDetails,
  setInvitedUsers,
} = teamSlice.actions;

export default teamSlice.reducer;
